import { cloneDeep } from 'lodash';

import { IObservable, Subject } from '~/rage/utils';

import { IChatChannel, IChatMessage, IChatService } from './chatServiceTypes';
import { chatStubData } from './stubData';

export class ChatServiceStub implements IChatService {
	private readonly stubData = chatStubData;

	private readonly activeChannelId = new Subject<string>(this.stubData[0].id);
	private readonly channels = new Subject<IChatChannel[]>(
		cloneDeep(this.stubData),
	);
	private readonly messages = new Subject<IChatMessage[]>(
		cloneDeep(this.stubData[0].messages),
	);
	private readonly sentMessages = new Subject<string[]>([]);
	private readonly chatWidth = new Subject<number>(335);
	private readonly chatHeight = new Subject<number>(306);

	constructor() {
		let t = 600;

		setInterval(
			() => {
				t -= 5;
				this.stubData[1].messages.push({
					id: 'auction-msg-stub',
					sender: 'СИСТЕМА',
					text: `Аукцион завершится через ${t} секунд`,
					color: { r: 255, g: 70, b: 70 },
				});
				if (this.activeChannelId.getValue() !== this.stubData[1].id) {
					this.stubData[1].hasUnreadMessages = true;
				} else {
					this.messages.next(cloneDeep(this.stubData[1].messages));
				}
				this.channels.next(cloneDeep(this.stubData));
			},
			5000,
			t,
		);

		(window as any).resizeChat = (width: number, height: number) => {
			this.chatWidth.next(width);
			this.chatHeight.next(height);
		};

		(window as any).sendChatMessage = (message: string) => {
			this.sendMessage(message);
		};
	}

	public getChannels(): IObservable<IChatChannel[]> {
		return this.channels;
	}

	public setActiveChannelId(channelId: string): void {
		this.activeChannelId.next(channelId);
		this.messages.next(
			cloneDeep(this.stubData.find((c) => c.id === channelId)?.messages || []),
		);
		const channel = this.stubData.find((c) => c.id === channelId);
		if (channel) {
			channel.hasUnreadMessages = false;
			this.channels.next(cloneDeep(this.stubData));
		}
	}

	public getActiveChannelId(): IObservable<string> {
		return this.activeChannelId;
	}

	public getMessages(): IObservable<IChatMessage[]> {
		return this.messages;
	}

	public async sendMessage(message: string): Promise<void> {
		const channel = this.stubData.find(
			(c) => c.id === this.activeChannelId.getValue(),
		);
		if (channel) {
			setTimeout(() => {
				channel.messages.push({
					id: 'msg-test',
					sender: 'Tester',
					text: message,
					color: { r: 255, g: 150, b: 0 },
				});
				this.channels.next(cloneDeep(this.stubData));
				if (this.activeChannelId.getValue() === channel.id) {
					this.messages.next(cloneDeep(channel.messages));
				} else {
					channel.hasUnreadMessages = true;
					this.channels.next(cloneDeep(this.stubData));
				}
			}, 500);
		}

		const sentMessages = this.sentMessages.getValue();
		sentMessages.push(message);
	}

	public getSentMessages(): IObservable<string[]> {
		return this.sentMessages;
	}

	public async setCursorVisible(visible: boolean): Promise<void> {
		console.log('setCursorVisible', { visible });
	}

	public getChatWidth(): IObservable<number> {
		return this.chatWidth;
	}

	public getChatHeight(): IObservable<number> {
		return this.chatHeight;
	}

	public deleteMessage(channelId: string, messageId: string): void {
		const channel = this.stubData.find((c) => c.id === channelId);
		if (!channel) {
			return;
		}

		const messageIndex = channel.messages.findIndex((m) => m.id === messageId);
		if (messageIndex === -1) {
			return;
		}

		channel.messages.splice(messageIndex, 1);

		if (this.activeChannelId.getValue() === channelId) {
			this.messages.next(cloneDeep(channel.messages));
		}
	}
}
